<template>
  <div class="web-003-home">
    <carousel
      v-if="rotationList.length"
      :list="rotationList"
    />
    <div :class="['web-content', isEmpty && 'empty']">
      <template v-for="(item,index) in contentList">
        <div
          v-if="item.styleId === 0"
          :key="index"
          class="item-div style0"
        >
          <homeColumnTitle
            :title="item.catalogName"
            :catalog-id="item.catalogId"
          />
          <leftDate_rightTitle
            :title="item.catalogName"
            :root-id="item.catalogId"
            :list="item.list"
          />
        </div>
        <div
          v-if="item.styleId === 1"
          :key="index"
          class="item-div style1"
        >
          <homeColumnTitle
            :title="item.catalogName"
            :catalog-id="item.catalogId"
          />
          <leftCover_rightTitle
            :title="item.catalogName"
            :root-id="item.catalogId"
            :list="item.list"
          />
        </div>
        <div
          v-if="item.styleId === 2"
          :key="index"
          class="item-div style2"
        >
          <homeColumnTitle
            :title="item.catalogName"
            :catalog-id="item.catalogId"
          />
          <topCover_bottomTitle
            :title="item.catalogName"
            :root-id="item.catalogId"
            :list="item.list"
          />
        </div>
        <contentDetail
          v-if="item.styleId === null || item.styleId === 'null'"
          :key="index"
          :list="item.list"
          class="item-div"
        />
      </template>
      <links
        v-show="linkNum"
        class="item-div"
        title="友情链接"
        @linkNum="linkNum = $event"
      />
      <div
        v-if="isEmpty"
        class="no-data"
      />
    </div>
  </div>
</template>

<script>
import api from '../../proxy';
import carousel from '../components/carousel';
import leftDate_rightTitle from '../components/homeTemplate/leftDate_rightTitle';
import leftCover_rightTitle from '../components/homeTemplate/leftCover_rightTitle';
import topCover_bottomTitle from '../components/homeTemplate/topCover_bottomTitle';
import contentDetail from '../components/homeTemplate/contentDetail';
import links from '../components/homeTemplate/links';
import homeColumnTitle from '../components/homeColumnTitle';
export default {
    name: 'Home',
    components: {
        carousel,
        leftDate_rightTitle,
        leftCover_rightTitle,
        topCover_bottomTitle,
        contentDetail,
        links,
        homeColumnTitle,
    },
    data () {
        return {
            websiteMsg: {},
            rotationList: [],
            contentList: [],
            linkNum: -1,
            loading: true,
        };
    },
    computed: {
        isEmpty () {
            return !this.loading && this.rotationList.length === 0 && this.contentList.length === 0 && this.linkNum === 0;
        },
    },
    async created () {
        try {
            this.websiteMsg = JSON.parse(sessionStorage.getItem('websiteMsg')) || {};
        } catch (e) { return; }
        const res = await api.getRotationList({
            siteId: this.websiteMsg.id,
            pageNo: 1,
            pageSize: 999,
        });
        if (res.errcode === 0) {
            this.rotationList = res.data.list.filter(itm => itm.status === 1);
        } else {
            this.$message.error(res.errmsg);
        }
        const res1 = await api.catalogContentList({ siteId: this.websiteMsg.id });
        if (res1.errcode === 0) {
            this.contentList = res1.data;
        } else {
            this.$message.error(res1.errmsg);
        }
        this.loading = false;
    },
};
</script>

<style scoped lang="scss">
.web-003-home {
    width: 100%;
    min-height: calc(100vh - 200px);
    .web-content {
        width: 100%;
        box-sizing: border-box;
        background-color: #FFFFFF;
        .item-div {
            box-sizing: border-box;
            padding: 40px 0;
            &.style0 {
                background-color: #FFFFFF;
            }
            &.style1 {
                background-color: #F9F9F9;
            }
            &.style2 {
                background-color: #F9F9F9;
            }
        }
        &.empty{
            padding-top: 30px;
            .no-data {
                width: 100%;
                height: 400px;
                background: url("../../../../../assets/image/no_data.png") center no-repeat;
            }
        }
    }
}
</style>
